import { Component, OnInit } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Utils } from '../../utils';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ShareService, ShareProvider } from '../../services/share.service';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

export class TradeClosedNotificationParams
{
  constructor(
    public FillPrice: number = 0,
    public Pips: number = 0,
    public Profit: number = 0,
    public Qty: number = 0,
    public Symbol: string = '',
    public partialClose:boolean = false,
    public error:string | null = null
  ){}
}
@Component({
  selector: '[trade-closed-notification]',
  template: require('./trade-closed-notification.component.html'),
  styles: [require('./trade-closed-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ]),
],
preserveWhitespaces: false,
})
export class TradeClosedNotificationComponent extends Toast implements OnInit 
{
  params: TradeClosedNotificationParams;

  public get decimals()
  {
    const box = this.workspaceService.data.boxes.find(b => b.Symbol == this.params.Symbol);
    if(box == null)
      return 5;

    return box.Decimal;
  }
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, protected shareService: ShareService, protected workspaceService: WorkspaceServiceService) 
  {
    super(toastrService, toastPackage);
    this.params = JSON.parse(Utils.decodeHTMLEntities(this.message as string));
  }

  ngOnInit() {
  }

  public share(provider: string) {
    this.shareService.shareWithSvg(provider, this.getShareText());
  }

  getShareText()
  {
    return Math.random() < 0.5?
     'Hey, I just captured (' + (this.params.Pips>0? '+': '') + this.params.Pips + ' Pips) trading with PremiereTrade.  Check it out !!! #PremiereTrade #Forex #ForexTrading':
     'What a TRADE! Just profited (' + (this.params.Pips>0? '+': '') + this.params.Pips + ' Pips) using #PremiereTrade.  Check it out !!! #Forex #ForexTrading';
  }

  public get Type(){return "" }
  public get Error(){return "" }
  
}

